// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/bi',
    name: 'BI',
    component: layout,
    redirect: '/bi/brandSet',
    meta: {
      title: 'BI',
      icon: 'i-menu:brand',
      i18Key: 'router.user.bi.title',
      roles: [1],
      category: 'setting'
    },
    sort: 10,
    children: [
      {
        path: 'brandSet',
        name: 'BrandSet',
        component: () => import('@/views/BI/BrandSet/Index.vue'),
        meta: {
          title: '品牌设置',
          icon: 'i-menu:brand',
          i18Key: 'router.user.bi.brandSet',
          roles: [1],
          headerConditions: ['brand']
        }
      }
      // {
      //   path: 'rank',
      //   name: 'BIRank',
      //   component: () => import('@/views/BI/Rank.vue'),
      //   hiddenInMenu: true,
      //   meta: {
      //     title: 'BI-Rank',
      //     icon: 'i-menu:brand',
      //     i18Key: 'router.user.bi.biRank',
      //     roles: [1],
      //     headerConditions: ['brand']
      //   }
      // },
      // {
      //   path: 'citation',
      //   name: 'BICitation',
      //   component: () => import('@/views/BI/Citation.vue'),
      //   hiddenInMenu: true,
      //   meta: {
      //     title: 'BI-Citation',
      //     icon: 'i-menu:brand',
      //     i18Key: 'router.user.bi.biCitation',
      //     roles: [1],
      //     headerConditions: ['brand']
      //   }
      // },
      // {
      //   path: 'sentiment',
      //   name: 'BISentiment',
      //   component: () => import('@/views/BI/Sentiment.vue'),
      //   hiddenInMenu: true,
      //   meta: {
      //     title: 'BI-Sentiment',
      //     icon: 'i-menu:brand',
      //     i18Key: 'router.user.bi.biSentiment',
      //     roles: [1],
      //     headerConditions: ['brand']
      //   }
      // },
      // {
      //   path: 'queryAnalysis',
      //   name: 'BIQueryAnalysis',
      //   component: () => import('@/views/BI/QueryAnalysis.vue'),
      //   hiddenInMenu: true,
      //   meta: {
      //     title: 'BI-QueryAnalysis',
      //     icon: 'i-menu:brand',
      //     i18Key: 'router.user.bi.biQueryAnalysis',
      //     roles: [1],
      //     headerConditions: ['brand']
      //   }
      // },
      // {
      //   path: 'visibility',
      //   name: 'BIVisibility',
      //   component: () => import('@/views/BI/Visibility.vue'),
      //   hiddenInMenu: true,
      //   meta: {
      //     title: 'BI-Visibility',
      //     icon: 'i-menu:brand',
      //     i18Key: 'router.user.bi.biVisibility',
      //     roles: [1],
      //     headerConditions: ['brand']
      //   }
      // }
    ]
  }
]
export default routes
